export function getContributionEligibility({
  jobConsumerId = null,
  participantId,
  activeWorkerJobId = null,
  walletRequired = false,
  walletSessionReady = false,
  hasDeviceReceipt = false,
  runtimeReady = false,
  qualificationState = null,
  qualificationExpiresAt = null,
  bondingRequired = false,
  bondEligible = false,
  now = Date.now()
}) {
  if (jobConsumerId && jobConsumerId === participantId) {
    return { allowed: false, buttonLabel: "Your job", title: "Consumer wallet", detail: "A wallet cannot claim its own request. Connect a different qualified contributor.", tone: "locked" };
  }
  if (activeWorkerJobId) {
    return { allowed: false, buttonLabel: "Worker busy", title: "Worker already active", detail: "Finish or stop the current render before claiming another packet.", tone: "active" };
  }
  if (walletRequired && (!walletSessionReady || !/^0x[0-9a-f]{40}$/.test(participantId))) {
    return { allowed: false, buttonLabel: "Connect wallet", title: "Wallet session required", detail: "Connect and sign the free login message before qualifying this device.", tone: "locked" };
  }
  if (qualificationState === "qualified" && Date.parse(qualificationExpiresAt) <= now) {
    return { allowed: false, buttonLabel: "Re-qualify GPU", title: "Contributor grant expired", detail: "Run the canonical workload again to renew this device and wallet grant.", tone: "locked" };
  }
  if (qualificationState === "pending") {
    return { allowed: false, buttonLabel: "Quorum pending", title: "Verifier quorum pending", detail: "The canonical output is waiting for two independent verifier workers.", tone: "active" };
  }
  if (!hasDeviceReceipt && qualificationState !== "qualified") {
    return { allowed: false, buttonLabel: "Check GPU first", title: "Device check required", detail: "Measure WebGPU capability before downloading the pinned model pack.", tone: "locked" };
  }
  if (!runtimeReady) {
    return { allowed: false, buttonLabel: "Install model first", title: "Model runtime required", detail: "Install the pinned FLUX.2 Klein pack and keep it loaded in this browser.", tone: "locked" };
  }
  if (qualificationState !== "qualified") {
    return { allowed: false, buttonLabel: "Run canonical render", title: "Canonical render required", detail: "Complete the fixed workload so verifier workers can issue a contributor grant.", tone: "locked" };
  }
  if (bondingRequired && !bondEligible) {
    return {
      allowed: false,
      buttonLabel: "Stake to work",
      title: "Bonded capacity required",
      detail: "Deposit or unlock enough worker stake to collateralize this bounty before claiming it.",
      tone: "locked"
    };
  }
  return { allowed: true, buttonLabel: "Claim", title: "Contributor grant active", detail: "Wallet, runtime, canonical output, and verifier quorum are ready.", tone: "ready" };
}
